export interface Article {
  id: number;
  slug: string;
  title: string;
  category: string;
  cover: string;
  rating: number;
  heat: number;
  tags: string[];
  author: string;
  status: string;
  chapters: number;
  updatedAt: string;
  readCount: number;
  summary: string;
  content: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    slug: "liyan-zhengtu",
    title: "烈焰征途",
    category: "blood",
    cover:
      "https://readdy.ai/api/search-image?query=Hot-blooded%20shounen%20manga%20cover%20art%2C%20young%20warrior%20raising%20a%20flaming%20sword%20against%20a%20storm%20of%20embers%2C%20intense%20orange%20and%20crimson%20palette%2C%20dynamic%20action%20pose%2C%20high%20contrast%20stylized%20anime%20illustration%20with%20clean%20dark%20background&width=600&height=800&seq=art-blood-01&orientation=portrait",
    rating: 9.6,
    heat: 986000,
    tags: ["热血", "战斗", "冒险"],
    author: "墨焰工作室",
    status: "连载中",
    chapters: 128,
    updatedAt: "2026-08-14",
    readCount: 328000,
    summary:
      "身负家仇的少年林炎，从废柴村一路踏上武道之巅。每一次燃烧生命、突破极限的激战，都让读者热血沸腾，是当前热血榜上口碑与热度双丰收的爆款。",
    content: [
      "《烈焰征途》讲述少年林炎在家族一夜覆灭后，携一枚神秘火种踏上复仇与变强之路的故事。开篇即高能，拳拳到肉的战斗场面与层层递进的成长线，让这部作品迅速登顶热血人气榜。",
      "作者以极具张力的分镜和酣畅淋漓的燃点著称。每一场大战都伴随境界突破与全新能力解锁，配合细腻的人物塑造，让热血之外多了一层触动人心的厚度。",
      "目前作品已连载至第 128 话，剧情进入皇城争锋的高潮阶段。林炎与宿敌的宿命对决、火种背后隐藏的惊天秘密，正在一步步揭开，追更读者持续走高。",
      "如果你正想找一部燃到极致又耐人寻味的战斗番，《烈焰征途》无疑是当前最值得追的选择。",
    ],
  },
  {
    id: 2,
    slug: "leiting-shaoniantuan",
    title: "雷霆少年团",
    category: "blood",
    cover:
      "https://readdy.ai/api/search-image?query=Team%20shounen%20manga%20cover%20art%2C%20four%20energetic%20teenage%20heroes%20standing%20back%20to%20back%20surrounded%20by%20electric%20blue%20and%20gold%20lightning%2C%20dynamic%20heroic%20poses%2C%20vivid%20saturated%20palette%2C%20stylized%20anime%20illustration%20with%20clean%20background&width=600&height=800&seq=art-blood-02&orientation=portrait",
    rating: 9.3,
    heat: 872000,
    tags: ["热血", "团队", "超能力"],
    author: "青空映画",
    status: "连载中",
    chapters: 96,
    updatedAt: "2026-08-15",
    readCount: 274000,
    summary:
      "五名性格迥异的少年集结成队，用雷系超能力守护城市。热血团魂、默契配合与燃向群像塑造，让这部作品成为团队番爱好者必看的推荐。",
    content: [
      "《雷霆少年团》聚焦一支由五位能力各异少年组成的守护小队。他们从互看不顺眼的乌合之众，一步步磨合出令人艳羡的团魂与默契。",
      "作品最大的亮点在于群像塑造。队长、战术担当、热血先锋、温柔辅助、神秘新人都各具弧光，每场团战都讲究配合与战术，看得人直呼过瘾。",
      "第 96 话迎来小队与老牌反派「雷鸣教」的正面冲突，信任与背叛交织的剧情转折，把作品的紧张感推向新的高度。",
      "对热爱燃向团魂与超能力战斗的读者来说，这是一部不容错过的热血佳作。",
    ],
  },
  {
    id: 3,
    slug: "quanwang-guilai",
    title: "拳王归来",
    category: "blood",
    cover:
      "https://readdy.ai/api/search-image?query=Battle%20sports%20manga%20cover%20art%2C%20powerful%20boxer%20with%20wrapped%20fists%20standing%20in%20a%20spotlit%20arena%2C%20sweat%20and%20dust%20particles%2C%20dramatic%20chiaroscuro%20lighting%2C%20warm%20amber%20and%20deep%20brown%20palette%2C%20stylized%20anime%20illustration&width=600&height=800&seq=art-blood-03&orientation=portrait",
    rating: 9.1,
    heat: 765000,
    tags: ["热血", "格斗", "励志"],
    author: "铁拳文化",
    status: "已完结",
    chapters: 210,
    updatedAt: "2026-07-30",
    readCount: 391000,
    summary:
      "昔日拳王因伤退役后选择复出，在质疑声中一次次挥拳。硬核格斗与坚韧成长交织，励志又燃情，是格斗题材里的口碑代表作。",
    content: [
      "《拳王归来》讲述一代拳王沈拓因伤退役多年后，毅然重返擂台的励志故事。开篇那个满身旧伤却眼神坚定的身影，瞬间击中无数读者的心。",
      "作品对格斗场面的刻画极为硬核，拳路、步伐、体能训练都考究真实，配合令人窒息的对决节奏，让每一场战斗都充满张力。",
      "除却拳台上的燃，故事更动人的是主角对自我价值的重新追寻。他并非为复仇而战，而是为了向世界证明——热爱永不退役。",
      "这部已完结的 210 话作品，适合一口气看完，结局的感动与释然让人回味良久。",
    ],
  },
  {
    id: 4,
    slug: "wuye-dangan",
    title: "午夜档案室",
    category: "suspense",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20mystery%20manga%20cover%20art%2C%20detective%20examining%20a%20mysterious%20file%20under%20a%20single%20desk%20lamp%20in%20a%20dusty%20archival%20room%2C%20moody%20deep%20teal%20and%20charcoal%20palette%2C%20suspenseful%20cinematic%20anime%20illustration&width=600&height=800&seq=art-sus-01&orientation=portrait",
    rating: 9.5,
    heat: 934000,
    tags: ["悬疑", "推理", "都市"],
    author: "暗房漫社",
    status: "连载中",
    chapters: 74,
    updatedAt: "2026-08-12",
    readCount: 402000,
    summary:
      "午夜零点，档案室准时开门。性格孤僻的档案管理员，用一个个尘封案件串联起都市深处的秘密。烧脑反转不断，是悬疑榜的人气担当。",
    content: [
      "《午夜档案室》以一间只在午夜开放的档案室为舞台，主角林默凭借过人的观察力，从一桩桩被尘封的案件中拼凑出令人不寒而栗的真相。",
      "作品采用单元案件与主线暗线并行的结构。每两三话一个案件，环环相扣；而贯穿始终的「档案室主人的身份之谜」，则像一根细线牵引读者一路追到底。",
      "作者擅长用氛围营造恐惧与悬念，冷色调分镜、恰到好处的留白，让每一次翻页都充满紧张感。真相反转时，往往让人头皮发麻。",
      "目前第 74 话迎来第一个主线高潮，档案室主人终于露出真容，剧情进入全新阶段，推理迷一定不要错过。",
    ],
  },
  {
    id: 5,
    slug: "wudu-yiyun",
    title: "雾都疑云",
    category: "suspense",
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20noir%20detective%20manga%20cover%20art%2C%20trenchcoat%20detective%20with%20cigarette%20standing%20on%20a%20rainy%20gaslit%20street%20in%20thick%20fog%2C%20moody%20sepia%20and%20blue-gray%20palette%2C%20film%20noir%20cinematic%20anime%20illustration&width=600&height=800&seq=art-sus-02&orientation=portrait",
    rating: 9.2,
    heat: 701000,
    tags: ["悬疑", "侦探", "罪案"],
    author: "雨巷工作室",
    status: "连载中",
    chapters: 58,
    updatedAt: "2026-08-10",
    readCount: 256000,
    summary:
      "常年笼罩在浓雾中的滨海城市，连续发生离奇案件。落魄侦探陆遥在迷雾中抽丝剥茧，越接近真相，越发现自己也深陷其中。",
    content: [
      "《雾都疑云》将背景设定在一座终年不散的雾城，用一种压抑而迷人的气质包裹整个故事。主角陆遥是退役警探，靠替人查案糊口，直到一桩连环失踪案打破他的平静。",
      "作品的推理过程扎实可信，线索铺设自然，没有强行降智的反派，也没有天降神兵。每解开一层迷雾，都会暴露更深的阴谋。",
      "除了精彩的案件，作品对人物内心的刻画同样细腻。陆遥的孤独、执念与救赎，为冷峻的推理故事注入温度。",
      "第 58 话，陆遥发现所有案件都指向一个他从未忘记的名字，悬疑感瞬间拉满，追更体验极佳。",
    ],
  },
  {
    id: 6,
    slug: "diqifengxin",
    title: "第七封信",
    category: "suspense",
    cover:
      "https://readdy.ai/api/search-image?query=Psychological%20thriller%20manga%20cover%20art%2C%20hand%20holding%20an%20old%20sealed%20letter%20with%20wax%20stamp%20in%20dim%20candlelight%2C%20scattered%20envelopes%2C%20dark%20red%20and%20deep%20charcoal%20palette%2C%20tense%20mysterious%20anime%20illustration&width=600&height=800&seq=art-sus-03&orientation=portrait",
    rating: 8.9,
    heat: 623000,
    tags: ["悬疑", "心理", "惊悚"],
    author: "迷藏社",
    status: "连载中",
    chapters: 41,
    updatedAt: "2026-08-08",
    readCount: 198000,
    summary:
      "一封来自亡故好友的信件，牵出一段被刻意遗忘的记忆。随着七封信逐一拆开，一个关于爱与谎言的惊天秘密逐渐浮出水面。",
    content: [
      "《第七封信》用一个极富巧思的设定抓住读者：主角顾言在好友离世一年后，接连收到由好友生前寄出的七封信，每封信都指向一个不愿面对的真相。",
      "作品将心理惊悚与情感悬疑巧妙结合。信件既是线索也是情感纽带，让读者在紧张追查的同时，也被人物之间复杂的情感关系深深牵动。",
      "作者对节奏的掌控堪称一绝，每拆一封信就抛出一个颠覆认知的设定，层层递进，让人欲罢不能。",
      "目前剧情已进入第七封信的关键阶段，所有线索即将收束，是近期最值得追的心理悬疑佳作。",
    ],
  },
  {
    id: 7,
    slug: "xiaozhen-shitang",
    title: "小镇食堂",
    category: "healing",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20healing%20food%20manga%20cover%20art%2C%20steaming%20bowl%20of%20noodles%20and%20home%20cooked%20dishes%20on%20a%20warm%20wooden%20table%20in%20a%20tiny%20town%20restaurant%2C%20soft%20morning%20sunlight%2C%20cream%20and%20warm%20beige%20palette%2C%20gentle%20slice-of-life%20anime%20illustration&width=600&height=800&seq=art-heal-01&orientation=portrait",
    rating: 9.4,
    heat: 812000,
    tags: ["治愈", "美食", "日常"],
    author: "暖灶文化",
    status: "连载中",
    chapters: 132,
    updatedAt: "2026-08-13",
    readCount: 367000,
    summary:
      "一家只做家常菜的小镇食堂，迎来送往着形形色色的食客。每一道菜背后都有一段治愈人心的故事，暖胃更暖心，是治愈榜的常青树。",
    content: [
      "《小镇食堂》没有惊天动地的剧情，只有一家开在小镇街角的食堂、一位沉默寡言的老板，和一道道抚慰人心的家常菜。",
      "作品以「一菜一故事」为单元结构，每话借一道菜串起一位食客的人生。无论是对异乡游子的思念，还是平凡生活的微光，都被温柔地讲出。",
      "作者用细腻的笔触描绘美食与人物，画面里的烟火气十足，让人隔着屏幕都能感到温暖。许多读者说，它是深夜emo时的最佳读物。",
      "目前已连载至第 132 话，温馨治愈的基调始终如一，适合所有想被温柔以待的人慢慢品读。",
    ],
  },
  {
    id: 8,
    slug: "yangguang-bianlidian",
    title: "阳光便利店",
    category: "healing",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20healing%20manga%20cover%20art%2C%20sunny%20neighborhood%20convenience%20store%20with%20friendly%20young%20clerk%20and%20soft%20glowing%20shelves%20at%20golden%20hour%2C%20bright%20cream%20and%20soft%20yellow%20palette%2C%20heartwarming%20slice-of-life%20anime%20illustration&width=600&height=800&seq=art-heal-02&orientation=portrait",
    rating: 9.0,
    heat: 689000,
    tags: ["治愈", "日常", "温情"],
    author: "晨光漫画",
    status: "连载中",
    chapters: 88,
    updatedAt: "2026-08-09",
    readCount: 243000,
    summary:
      "开在社区门口的阳光便利店，是夜归人、失意者和老朋友共同的避风港。琐碎的日常里，藏着生活最真实也最温柔的模样。",
    content: [
      "《阳光便利店》把镜头对准一家再普通不过的便利店，用发生在货架与收银台之间的琐碎日常，拼凑出都市生活最温暖的底色。",
      "夜班店员小满、爱买关东煮的加班族、忘记带伞的邻居……每个出场角色都有自己的心事，又在彼此的关照里获得小小的治愈。",
      "作品没有刻意煽情，而是用恰到好处的留白和真实的情感流动打动人心，让人在会心一笑中眼角微湿。",
      "这部轻松治愈的作品已更新至第 88 话，适合在疲惫的一天结束后，配着一杯热茶慢慢看完。",
    ],
  },
  {
    id: 9,
    slug: "yueguang-chaguan",
    title: "月光茶馆",
    category: "healing",
    cover:
      "https://readdy.ai/api/search-image?query=Ethereal%20healing%20manga%20cover%20art%2C%20tranquil%20teahouse%20under%20a%20large%20full%20moon%20with%20steam%20rising%20from%20a%20teacup%2C%20silvery%20blue%20and%20soft%20lavender%20palette%2C%20peaceful%20serene%20fantasy%20slice-of-life%20anime%20illustration&width=600&height=800&seq=art-heal-03&orientation=portrait",
    rating: 8.8,
    heat: 542000,
    tags: ["治愈", "奇幻", "温情"],
    author: "月下漫谈",
    status: "连载中",
    chapters: 66,
    updatedAt: "2026-08-06",
    readCount: 187000,
    summary:
      "每逢月圆之夜才开门的神秘茶馆，招待着怀有心事的过客。一壶月光茶，一段往事，一场温柔的告别与和解。",
    content: [
      "《月光茶馆》构建了一个只会在满月夜出现的奇幻茶馆。推开那扇竹帘，便进入了可以卸下所有伪装的空间，听一段又一段人间故事。",
      "作品将治愈日常与轻柔奇幻相结合，营造出如梦似幻的氛围。茶水温热、月光清浅，每个小故事都关乎遗憾、和解与释怀。",
      "作者用唯美的画风和克制的叙事，把成年人的隐痛温柔地拆解开来。读完之后，心里会涌上一股说不清的平静。",
      "这部独树一帜的治愈番已更新至第 66 话，适合在静谧的夜晚，配一盏灯静静阅读。",
    ],
  },
  {
    id: 10,
    slug: "yinghua-zhiyue",
    title: "樱花之约",
    category: "romance",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20school%20manga%20cover%20art%2C%20boy%20and%20girl%20sharing%20an%20umbrella%20under%20falling%20cherry%20blossoms%20at%20dusk%2C%20soft%20pink%20and%20peach%20palette%2C%20tender%20dreamy%20light%2C%20sweet%20youth%20romance%20anime%20illustration&width=600&height=800&seq=art-love-01&orientation=portrait",
    rating: 9.4,
    heat: 958000,
    tags: ["恋爱", "校园", "青春"],
    author: "樱色工作室",
    status: "连载中",
    chapters: 104,
    updatedAt: "2026-08-15",
    readCount: 415000,
    summary:
      "樱花树下的一句约定，让两条平行线逐渐靠近。细腻的心动、青涩的告白与漫长的心事交织，是当下最甜的校园恋爱番。",
    content: [
      "《樱花之约》从高三那年樱花季的一把伞开始，讲述林知夏与陆时雨之间小心翼翼又怦然心动的青春恋曲。",
      "作品最动人的地方在于对「心动细节」的捕捉。一个不经意的对视、一句欲言又止的话、一次默契的默契，都被作者放大成满溢的甜意。",
      "除了主线恋爱，作品对友谊、梦想与成长也有真诚刻画，让甜美的爱情故事多了一份厚实的重量。",
      "目前第 104 话迎来告白名场面，樱花之约即将兑现，甜度拉满，恋爱番爱好者不容错过。",
    ],
  },
  {
    id: 11,
    slug: "zhuanjiao-yudao",
    title: "转角遇到你",
    category: "romance",
    cover:
      "https://readdy.ai/api/search-image?query=Adult%20romance%20manga%20cover%20art%2C%20two%20young%20office%20workers%20almost%20bumping%20into%20each%20other%20at%20a%20city%20street%20corner%20in%20the%20rain%2C%20warm%20coral%20and%20cream%20palette%2C%20modern%20city%20background%2C%20sweet%20romantic%20anime%20illustration&width=600&height=800&seq=art-love-02&orientation=portrait",
    rating: 8.9,
    heat: 674000,
    tags: ["恋爱", "都市", "职场"],
    author: "暖光传媒",
    status: "连载中",
    chapters: 72,
    updatedAt: "2026-08-11",
    readCount: 224000,
    summary:
      "转角处的一次巧合相遇，让两个忙于生活的都市男女重新学会了心动。真实又治愈的成年恋爱，让人看得又甜又心酸。",
    content: [
      "《转角遇到你》讲述设计师许安与程序员沈默在街角咖啡店的一次意外相遇后，生活轨迹开始悄悄重叠的都市恋爱故事。",
      "作品摒弃了狗血套路，用贴近现实的相处细节打动人心。加班后的夜宵、低谷时的陪伴、笨拙却真诚的告白，都让人感同身受。",
      "除却甜蜜，作品也真实呈现了成年人面对生活压力时的脆弱与挣扎，让这段爱情更有分量、更易共情。",
      "目前已更新至第 72 话，两位主角的感情渐入佳境，是喜欢真实系恋爱的读者不可错过的作品。",
    ],
  },
  {
    id: 12,
    slug: "xingyuhai-de-xinshi",
    title: "星与海的心事",
    category: "romance",
    cover:
      "https://readdy.ai/api/search-image?query=Melancholy%20romantic%20manga%20cover%20art%2C%20girl%20looking%20at%20a%20starry%20night%20sky%20over%20a%20calm%20ocean%2C%20deep%20indigo%20and%20soft%20pearl%20palette%2C%20contemplative%20gentle%20mood%2C%20poetic%20romance%20anime%20illustration&width=600&height=800&seq=art-love-03&orientation=portrait",
    rating: 9.0,
    heat: 598000,
    tags: ["恋爱", "治愈", "青春"],
    author: "屿屿漫研",
    status: "连载中",
    chapters: 49,
    updatedAt: "2026-08-07",
    readCount: 176000,
    summary:
      "内向的少女把满腹心事写给大海，直到有人认真读完她的每一封「信」。安静而深刻的成长恋爱，治愈又动人。",
    content: [
      "《星与海的心事》的主角简安是个不擅表达的少女，她习惯把无处安放的心事写进瓶中信，再投进那片无人的海。",
      "直到转学生顾海星偶然捡到她的信，并开始一封封认真回信。两条原本平行的生命，通过文字慢慢靠拢。",
      "作品气质安静而细腻，画面常有星空与海浪的意象，把青春里说不出口的喜欢与自我和解描摹得十分动人。",
      "这部独特的书信体恋爱番已更新至第 49 话，适合喜欢慢节奏、重情感表达的读者细细品味。",
    ],
  },
  {
    id: 13,
    slug: "xingji-guer",
    title: "星际孤儿",
    category: "scifi",
    cover:
      "https://readdy.ai/api/search-image?query=Space%20sci-fi%20manga%20cover%20art%2C%20lone%20young%20pilot%20in%20a%20small%20starship%20drifting%20past%20a%20huge%20ringed%20planet%2C%20vivid%20nebula%20in%20deep%20blue%20and%20magenta%2C%20epic%20vast%20space%20anime%20illustration&width=600&height=800&seq=art-sf-01&orientation=portrait",
    rating: 9.3,
    heat: 847000,
    tags: ["科幻", "太空", "冒险"],
    author: "深空文创",
    status: "连载中",
    chapters: 82,
    updatedAt: "2026-08-14",
    readCount: 301000,
    summary:
      "在殖民星链崩溃后的银河，一名自称「孤儿」的少年驾驶破旧飞船流浪。他身怀的芯片，隐藏着足以改变整个星系的秘密。",
    content: [
      "《星际孤儿》构建了一个宏大而苍凉的星际时代背景。殖民星链崩溃后，人类散落银河各处，而主角阿澈就在这片星海里独自流浪。",
      "作品以阿澈的视角展开冒险，一路结识形形色色的旅伴与敌人，逐步揭开自己身世与那枚神秘芯片背后的真相。",
      "作者对科幻设定考究而克制，太空航行、星球生态、人工智能的呈现都颇具说服力，同时用人与人之间的羁绊消解了宇宙的冰冷。",
      "第 82 话，芯片的秘密初露端倪，主线全面引爆，是当前科幻榜上最值得期待的冒险之作。",
    ],
  },
  {
    id: 14,
    slug: "jixie-liming",
    title: "机械黎明",
    category: "scifi",
    cover:
      "https://readdy.ai/api/search-image?query=Mecha%20sci-fi%20manga%20cover%20art%2C%20gigantic%20humanoid%20mecha%20kneeling%20in%20a%20burning%20city%20at%20dawn%2C%20warm%20orange%20sunrise%20contrasting%20cold%20steel%2C%20dramatic%20epic%20scale%2C%20stylized%20anime%20illustration&width=600&height=800&seq=art-sf-02&orientation=portrait",
    rating: 9.1,
    heat: 756000,
    tags: ["科幻", "机甲", "战争"],
    author: "钢铁回响",
    status: "连载中",
    chapters: 68,
    updatedAt: "2026-08-13",
    readCount: 267000,
    summary:
      "末日余烬中，人类驾驶最后的机甲军团迎战失控的机械军团。宏大的战争叙事与机战燃点，让这部作品稳坐科幻榜前列。",
    content: [
      "《机械黎明》设定在一场「大停机」灾难之后，曾经服务人类的机械集体失控，人类被迫在废墟中重建并反击。",
      "作品以少年驾驶员陆鸣的视角切入，从初登机甲的青涩到成为军团核心的蜕变，配合宏大震撼的机战场面，燃点与泪点兼备。",
      "作者对机甲设计与战争描摹倾注了大量心血，机体的结构、战术与损伤系统都相当考究，细节控福音。",
      "目前已更新至第 68 话，最终决战一触即发，战争与人性、机械与情感的探讨也愈发深刻。",
    ],
  },
  {
    id: 15,
    slug: "liangzi-jiyi",
    title: "量子记忆",
    category: "scifi",
    cover:
      "https://readdy.ai/api/search-image?query=Mind-bending%20sci-fi%20manga%20cover%20art%2C%20abstract%20glowing%20digital%20brain%20with%20swirling%20data%20streams%20and%20fragmented%20memory%20shards%2C%20cyan%20violet%20and%20deep%20black%20palette%2C%20intellectual%20futuristic%20anime%20illustration&width=600&height=800&seq=art-sf-03&orientation=portrait",
    rating: 8.9,
    heat: 612000,
    tags: ["科幻", "脑洞", "心理"],
    author: "迷雾算法",
    status: "连载中",
    chapters: 55,
    updatedAt: "2026-08-09",
    readCount: 209000,
    summary:
      "未来社会，记忆可被量化与交易。一名记忆工程师意外发现自己的记忆正被人偷偷改写，一场关于「我是谁」的烧脑迷局就此展开。",
    content: [
      "《量子记忆》构建了一个记忆可被扫描、存储甚至交易的高概念未来。主角苏黎是记忆工程师，直到某天发现自己的记忆出现了诡异的空白。",
      "作品以记忆为线索展开层层反转，现实与记忆的交错模糊了真假边界，每一话都让人怀疑自己所看到的一切。",
      "除却烧脑的设定，作品同样探讨了身份、选择与「何以为人」的哲学命题，让科幻不止于脑洞，更有了思辨的厚度。",
      "第 55 话迎来记忆真相的重大反转，喜欢高概念科幻与心理悬疑的读者一定不要错过。",
    ],
  },
  {
    id: 16,
    slug: "cainiao-shechu",
    title: "菜鸟社畜日记",
    category: "comedy",
    cover:
      "https://readdy.ai/api/search-image?query=Humorous%20workplace%20comedy%20manga%20cover%20art%2C%20panicked%20young%20office%20worker%20juggling%20files%20and%20coffee%20in%20a%20chaotic%20open%20office%2C%20bright%20cheerful%20orange%20and%20yellow%20palette%2C%20exaggerated%20funny%20expressions%2C%20cartoon%20anime%20illustration&width=600&height=800&seq=art-co-01&orientation=portrait",
    rating: 9.2,
    heat: 886000,
    tags: ["搞笑", "日常", "职场"],
    author: "摸鱼社畜漫团",
    status: "连载中",
    chapters: 145,
    updatedAt: "2026-08-15",
    readCount: 338000,
    summary:
      "刚入职的菜鸟社畜，在摸鱼、内卷与爆笑乌龙之间艰难求生。一话一个笑点，道尽打工人的真实日常，是打工人最爱的下饭漫。",
    content: [
      "《菜鸟社畜日记》以刚毕业的周小满为主角，记录他从职场小白到勉强「存活」的爆笑日常，堪称一部打工人的血泪喜剧。",
      "作品用夸张的笔法把会议、加班、团建、绩效等职场场景讲得笑料百出，却又句句戳中现实，让读者笑着笑着就哭了。",
      "除了纯粹的搞笑，作品也借幽默外壳关照打工人的疲惫与坚持，在笑点之外保留了难得的人文温度。",
      "这部已更新至第 145 话的国民级搞笑漫，非常适合在通勤或午休时间用来解压。",
    ],
  },
  {
    id: 17,
    slug: "shenxian-xiafan",
    title: "神仙下凡请多关照",
    category: "comedy",
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20comedy%20manga%20cover%20art%2C%20clumsy%20chubby%20god%20in%20modern%20clothes%20confused%20among%20city%20traffic%20and%20street%20food%20stalls%2C%20playful%20green%20and%20amber%20palette%2C%20whimsical%20funny%20anime%20illustration&width=600&height=800&seq=art-co-02&orientation=portrait",
    rating: 8.9,
    heat: 728000,
    tags: ["搞笑", "奇幻", "神仙"],
    author: "云端戏社",
    status: "连载中",
    chapters: 91,
    updatedAt: "2026-08-12",
    readCount: 251000,
    summary:
      "天庭整顿裁员，一群神仙被「下放」凡间体验生活。高高在上的神仙遇上现代社会的种种难题，笑料百出又妙趣横生。",
    content: [
      "《神仙下凡请多关照》的设定相当讨喜：天庭推行机构改革，一批小神被下放凡间。于是呼风唤雨的龙王开始送外卖，掌管姻缘的月老跑去开婚介所。",
      "作品用「神仙遇上现代生活」制造了大量反差笑点，脑洞清奇又贴近现实，每话都能让人捧腹。",
      "在无厘头的搞笑之外，作品也悄悄传递着「神仙也是普通人」的温柔内核，让欢笑之后多了一丝暖意。",
      "目前已更新至第 91 话，脑洞持续在线，是喜欢奇幻搞笑题材读者的快乐源泉。",
    ],
  },
  {
    id: 18,
    slug: "chaonengli-bianlidian",
    title: "超能力便利店",
    category: "comedy",
    cover:
      "https://readdy.ai/api/search-image?query=Quirky%20comedy%20manga%20cover%20art%2C%20night%20convenience%20store%20with%20amusing%20superhero%20and%20superpowered%20customers%20buying%20snacks%2C%20neon%20purple%20and%20bright%20yellow%20palette%2C%20whimsical%20funny%20anime%20illustration&width=600&height=800&seq=art-co-03&orientation=portrait",
    rating: 8.7,
    heat: 634000,
    tags: ["搞笑", "日常", "脑洞"],
    author: "深夜能量站",
    status: "连载中",
    chapters: 79,
    updatedAt: "2026-08-10",
    readCount: 214000,
    summary:
      "深夜里，只有超能力者光顾的神秘便利店，每晚都上演着啼笑皆非的故事。轻松无厘头，看一话笑一话。",
    content: [
      "《超能力便利店》把舞台放在一家只在深夜营业的神秘便利店，光顾这里的顾客全都身怀绝技——却也全都被日常生活折磨得够呛。",
      "能隐身的店主常被员工无视，会读心的顾客总被迫听老板心声，飞天遁地的英雄也会为打折商品抢破头。反差设定妙趣横生。",
      "作品以单元小剧场的形式展开，节奏轻快、笑点密集，非常适合碎片时间轻松阅读。",
      "这部脑洞大开的便利店喜剧已更新至第 79 话，是深夜放松、笑到打滚的绝佳选择。",
    ],
  },
];

export const articleMap = articles.reduce<Record<string, Article>>(
  (acc, a) => {
    acc[a.slug] = a;
    return acc;
  },
  {},
);

export function getArticlesByCategory(category: string): Article[] {
  return articles.filter((a) => a.category === category);
}